/**
 * Mobil "Sepete Ekle" - Seyran (sade buton + yonlendirme)
 *
 * - Mobilde (<=767px) temanin resimli/fiyatli sticky KARTINI gizler; yerine
 *   ekranin altina sabit, tam genislikte tek bir BORDO "Sepete ekle" butonu koyar.
 * - Butona basildiginda:
 *     * teslimat secimi eksikse -> EKLEMEZ, ilk eksik alana yumusakca kaydirir + bordo vurgu.
 *     * hepsi tamamsa -> asil sepete-ekle akisini tetikler (urunu ekler).
 *     * urun tukendiyse -> buton pasif ("Tukendi").
 * - Masaustunde (>=768px) bizim buton gizli; temanin kendi sticky'si calismaya devam eder.
 *   O kartin butonu icin de ayni yonlendirme document-capture ile uygulanir.
 */
(function () {
  var REQUIRED = ['city', 'district', 'neighborhood', 'date', 'time'];
  var TARGETS = {
    city: '[data-dropdown="city"]',
    district: '[data-dropdown="district"]',
    neighborhood: '[data-dropdown="neighborhood"]',
    date: '.delivery-date-grid',
    time: '.delivery-time-slot-wrapper'
  };
  var BORDO = '#741416';

  function log() {
    if (window.console && console.log) {
      console.log.apply(console, ['[seyran-atc]'].concat([].slice.call(arguments)));
    }
  }

  function injectStyles() {
    if (document.getElementById('seyran-atc-styles')) return;
    var s = document.createElement('style');
    s.id = 'seyran-atc-styles';
    s.textContent = [
      '.delivery-field-highlight{border-radius:8px;animation:seyranGuidePulse 1.1s ease-in-out 2;}',
      '@keyframes seyranGuidePulse{0%,100%{box-shadow:0 0 0 0 rgba(116,20,22,0);}50%{box-shadow:0 0 0 4px rgba(116,20,22,0.5);}}',
      '@media only screen and (max-width:767px){.product-add-to-cart-sticky{display:none !important;}}',
      '.seyran-sticky-atc{position:fixed;left:0;right:0;bottom:0;z-index:60;padding:10px 14px;padding-bottom:calc(10px + env(safe-area-inset-bottom,0px));background:rgba(255,251,240,0.97);box-shadow:0 -2px 14px rgba(67,39,29,0.16);transform:translateY(130%);transition:transform .25s ease;}',
      '.seyran-sticky-atc.is-visible{transform:translateY(0);}',
      '.seyran-sticky-atc button{display:block;width:100%;border:0;border-radius:10px;padding:15px 18px;font-size:1.0625rem;font-weight:600;letter-spacing:-.01em;line-height:1;color:#fff;background:' + BORDO + ';cursor:pointer;}',
      '.seyran-sticky-atc button:active{background:#5c1012;}',
      '.seyran-sticky-atc button[disabled]{opacity:.5;cursor:not-allowed;}',
      '@media only screen and (min-width:768px){.seyran-sticky-atc{display:none !important;}}'
    ].join('\n');
    document.head.appendChild(s);
  }

  function getMainAddButton() {
    return document.getElementById('AddToCart') ||
           document.querySelector('.product-form .single-add-to-cart-button:not(#AddToCartSticky)') ||
           document.querySelector('.single-add-to-cart-button:not(#AddToCartSticky)');
  }

  function isSoldOut(mainBtn) {
    return !!(mainBtn && mainBtn.classList.contains('sold-out'));
  }

  function firstMissing(wrapper) {
    for (var i = 0; i < REQUIRED.length; i++) {
      var key = REQUIRED[i];
      var input = wrapper.querySelector('[data-property="' + key + '"]');
      if (input && !String(input.value || '').trim()) {
        return key;
      }
    }
    return null;
  }

  function guide(wrapper, key) {
    var openSticky = document.querySelector('.product-add-to-cart-sticky details[open]');
    if (openSticky) openSticky.removeAttribute('open');

    var target = wrapper.querySelector(TARGETS[key]) || wrapper;
    try {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (e) {
      target.scrollIntoView();
    }
    target.classList.add('delivery-field-highlight');
    setTimeout(function () {
      target.classList.remove('delivery-field-highlight');
    }, 2200);
    log('eksik secim alanina yonlendirildi ->', key);
  }

  // Ortak karar: tiklamada ne yapilacak. true -> ekleme engellendi (yonlendirildi)
  function handleIntent() {
    var wrapper = document.querySelector('.delivery-info-selector-wrapper');
    if (!wrapper) return false;
    var missing = firstMissing(wrapper);
    if (missing) {
      guide(wrapper, missing);
      return true;
    }
    return false;
  }

  /* ---- Masaustu: temanin kart sticky butonu icin yonlendirme ---- */
  function onDocumentClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('#AddToCartSticky, .product-add-to-cart-sticky .single-add-to-cart-button');
    if (!btn) return;
    if (handleIntent()) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }

  /* ---- Mobil: sade bordo buton ---- */
  function buildMobileButton() {
    if (document.querySelector('.seyran-sticky-atc')) return;
    var mainBtn = getMainAddButton();

    var bar = document.createElement('div');
    bar.className = 'seyran-sticky-atc';
    var btn = document.createElement('button');
    btn.type = 'button';

    if (isSoldOut(mainBtn)) {
      btn.textContent = 'Tukendi';
      btn.disabled = true;
    } else {
      btn.textContent = 'Sepete ekle';
    }
    bar.appendChild(btn);
    document.body.appendChild(bar);

    btn.addEventListener('click', function () {
      var mb = getMainAddButton();
      if (isSoldOut(mb)) return;
      // teslimat eksikse yonlendir, ekleme
      if (handleIntent()) return;
      // her sey tamam -> asil ekleme akisini tetikle
      if (mb) {
        mb.removeAttribute('disabled');
        mb.style.opacity = '';
        mb.style.cursor = '';
        mb.click();
      }
    });

    setupVisibility(bar);
  }

  function setupVisibility(bar) {
    var anchor = getMainAddButton();
    if (!anchor || typeof IntersectionObserver === 'undefined') {
      bar.classList.add('is-visible');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // ana buton ekranda degilse bizim butonu goster
        bar.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  function init() {
    injectStyles();
    document.addEventListener('click', onDocumentClick, true);
    buildMobileButton();
    log('yuklendi');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
